/**
 * created by lei lei on 2020/5/28
 * 待我处理的活动
 */
import React, {Component} from 'react';
import ActivityPending from './NewActivityPending';
import {Tabs, Empty, Row, Col, message, Modal, Spin} from "antd";
import {formateData, headers, myReviewGridData} from "../../../../actions";
import {NAVIGATE_OPEN, NAVIGATE_CLOSE} from "../../../../constants";
import {connect} from "react-redux";
import {applicationName, formatDate, permissionCheck, timeago, uuid} from "../../../../utils";
import {
    shrinNavigateStauts,
    updateNavigateLevel2Data
} from "../../../../actions";
import moreImg from '../commImg/diandiandian.png';
import {getNewsActivityById} from "../../../../actions/interview";
import NewsActivityBaseInfo, {NewsActivityBaseInfoFooter} from "../../../../components/interview/NewsActivityBaseInfo";
import NewsActivityPublishPlatform from "../../../../components/interview/NewsActivityPublishPlatform";
import NewsActivityReporter from "../../../../components/interview/NewsActivityReporter";
import TabModal from "../../../../components/TabModal";
import NewsActivityWriteStory from "../../../../components/interview/NewsActivityWriteStory";
import NewsActivityPicture from "../../../../components/interview/NewsActivityPicture";
import NewsActivityVideo from "../../../../components/interview/NewsActivityVideo";
import NewsActivityArtFile from "../../../../components/interview/NewsActivityArtFile";
import {haveEditAuthRoleCode} from "../../../../containers/newsActivity/NewsActivityIndex";
import TaskAll from './TaskAll'
import {Scrollbars} from "react-custom-scrollbars";
import EditWeiBo from "../../../../components/weibo/editWeiBo";
import {MaterialModel} from "../../../mediaRelease/weChatPublish/WeChatPublish";

const {TabPane} = Tabs;

class ActivityPendingComponents extends Component {
    static defaultProps = {}
    static propTypes = {}

    ckqburl = "/interviewTask/interviewTask/1";
    nowType = 7;
    maxNum = 5;

/*    defaultHasAuthRoles = ["jsjz", "wzjz", "syjz", "sxjz", "bj"];
    isHasAuth = false;//是否有该组件的权限*/
    defaultStep = 0;
    weChatParams = {
        title: "编辑素材",
        materialId: 0,
        mediaCode: ""
    };

    constructor(props) {
        super(props);
        /*this.props.currentUser.roleCodes && this.props.currentUser.roleCodes.map(item => {
            if (this.defaultHasAuthRoles.indexOf(item) !== -1) {
                this.isHasAuth = true;
            }
        });*/

        this.state = {
            activeKey: '2',
            num1: 0,
            num2: 0,
            list: [],
            stepVisible: false,
            newsActivityViewVisible: false,
            newsActivityViewActiveIndex: 0,
            newsActivityViewTabs: [],
            newsActivityViewTabPanels: [],
            newsActivity: {},
            editWeiboVisible: false,
            loading: true,
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        let getMyTaskAuth = permissionCheck("pms:toDoListTask:viewAll");//是否展待我处理的任务
        let getMyOtherDateAuth = permissionCheck("pms:otherToDoList:viewAll");//是否展其他待我处理
        //两者都存在；
        if(getMyTaskAuth&&getMyOtherDateAuth){
            this.state.activeKey='2';
            this.getMyTask();
            this.getMyOtherDate()
        }
        //待我处理的存在，其他待我处理的不存在
        if(getMyTaskAuth&&!getMyOtherDateAuth){
            this.state.activeKey='1';
            this.getMyTask();
        }
        if(!getMyTaskAuth&&getMyOtherDateAuth){
            this.state.activeKey='2';
            this.getMyOtherDate()
        }
    }

    //获取待我处理的任务数据
    getMyTask() {
        this.state.num1=0;
        this.state.list=[];
        let body = {
            "start": 1,
            "size": 6,
            "interviewType": 1,
            "currentTime": new Date().getMilliseconds(),
        };
        getMyTask(body, data => {
            if (data && data.data) {
                if (this.state.activeKey === '2') {
                    this.setState({
                        num1: data.count,
                        loading:false
                    })
                }else{
                this.setState({
                    num1: data.count,
                    list: data.data,
                    loading:false
                })
                }
            }else{
                this.setState({
                    loading:false
                })
            }

        })
    }

    typeChaange(key) {
        this.state.activeKey = key;
        this.setState({loading: true,list:[]});
        if (key === '1') {
            this.setState({list:[]},()=>{
                this.getMyTask();
            });

        } else {
            this.setState({list:[]},()=>{
                this.getMyOtherDate()
            });
        }
    }

    getMyOtherDate() {
        // this.state.num2=0;
        this.state.list=[];
        getMyOther((data) => {
            if (data && data.data) {
                let storyList = data.data;
                let dataList = [];
                let forNum = 6;
                //  if(storyList.length <= forNum)
                // {
                forNum = storyList.length;
                // }
                for (let i = 0; i < forNum; i++) {
                    let story = storyList[i].data;
                    let type = this.getTitle(storyList[i]).type;
                    let icon = this.getIcon(storyList[i]);
                    let listObj = {};
                    let title = this.getTitle(storyList[i]).title;
                    listObj.record = storyList[i];
                    listObj.title = type;
                    listObj.icon = icon;
                    listObj.id = storyList[i].data.id;
                    listObj.content = title ? title : story.content;
                    if (story._deploymentKey && story._deploymentKey == "weixin") {
                        if (story.stuffList && story.stuffList.length > 0) {
                            listObj.content = story.stuffList[0].title;
                        }
                    }
                    listObj.statusMark = story.statusName;
                    listObj.timeMark = story.updateTime ? timeago(story.updateTime) : story.changeDate ? timeago(story.changeDate.time) : (story.updateDate ? timeago(story.updateDate.time) : "时间错误");
                    
                    
                    dataList.push(listObj);
                }
                if (this.state.activeKey === '1') {
                    this.setState({
                        num2: data.count,
                        loading:false
                    })
                }else{
                    let promiseArr = dataList.map((item, index) => {
                        return this.getStatus(item,index)
                    })
                    Promise.all(promiseArr).then(value => {
                        this.setState({
                            list: value,
                            num2: data.count,
                            loading:false
                        })
                    })
                }
            }else{
                this.setState({
                    loading:false
                })
            }

        });
    }

    getStatus = async (item,index) => {
      let  res = await checkLock({key : "story" + item.id});
      return {...item, lockStatus: res.lockStatus}
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    render() {

        let getMyTaskAuth = permissionCheck("pms:toDoListTask:viewAll");//是否展待我处理的任务
        let getMyOtherDateAuth = permissionCheck("pms:otherToDoList:viewAll");//是否展其他待我处理
        if(!getMyTaskAuth &&!getMyOtherDateAuth){
            return <div></div>
        }

        let menuWidth = parseInt(NAVIGATE_OPEN);
        if (!this.props.navigateStatus) {
            menuWidth = parseInt(NAVIGATE_CLOSE);
        }
        let dialogWidth = parseInt(window.$(window).width());
        let layoutWidth = (((dialogWidth - menuWidth - 40 - 40 - 80) * 0.55) / 4);
        let minWidth = 170;
        if (layoutWidth <= minWidth) {
            layoutWidth = minWidth;
        }
        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        const { loading } = this.state;
       
        return (
            <div className={'ActivityPendingComponents StaticMyDeskItemPaddingTop'} style={{width: '100%'}}>

                <div style={{background: '#FFFFFF', position: 'relative'}}>
                    <div className={'activityPending'} style={{
                        height: 58,
                        lineHeight: '58px',
                        background: 'white',
                        width: '100%',
                        float: 'left',
                        paddingTop:5,
                        paddingBottom:5,
                    }}>
                        <Tabs activeKey={this.state.activeKey}  onChange={(key) => {
                            this.typeChaange(key)
                        }}>
                            {getMyOtherDateAuth ? <TabPane tab={"其他待我处理" + "(" + (this.state.num2?this.state.num2:0) + ")"} key="2">
                            </TabPane> : null}
                            {
                                getMyTaskAuth? <TabPane tab={"待我处理的任务" + "(" + this.state.num1 + ")"} key="1">
                                </TabPane> : null
                            }

                        </Tabs>
                        <style>
                            {`
                            .activityPending .ant-tabs{
                                margin: 0 15px
                            }
            
           .activityPending .ant-tabs-tab-active {
                color: ${newSecondSelectColor} !important;
            }
            .activityPending .ant-tabs-nav .ant-tabs-tab:hover {
                color: ${newSecondSelectColor} !important;
            }
            .activityPending .ant-tabs-ink-bar{
            background-color:${newSecondSelectColor} !important;
            height:3px;
            }
            .activityPending  .ant-tabs-tab{
            font-size:16px !important ;
            font-weight:bold
            }
                             `}</style>
                        {this.state.activeKey === '1' ? <div onClick={() => {
                            // window.location.hash = this.ckqburl;
                            this.TaskAll.showTask({
                                topBtn: false
                            })
                        }} style={{
                            fontSize: 13,
                            right: 0,
                            color: '#0050B3',
                            float: 'right',
                            marginRight: 40,
                            cursor: 'pointer', position: 'absolute', top: -7,
                            paddingTop:5,
                            paddingBottom:5,
                        }}>
                            <img src={moreImg} alt=""/>
                        </div> : null}
                    </div>
                    <div style={{clear: 'both'}}/>
                    {
                        loading ? <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 360 }}><Spin /></div> : (
                            this.state.list.length === 0  ? <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 360 }}><Empty/>
                            </div> : (
                                 this.state.activeKey === '1' ? 
                                 <div style={{ height: 360, display: 'flex',padding: '10px 0 10px 10px', flexWrap:'wrap'}}>
                                    
                                 {
                                     this.state.list.map((item, index) => {
                                         if(index>5){
                                             return
                                         }
                                         return (
                                             <div className="item" key={index} style={{ marginRight: 10, marginBottom: '10px', width: 'calc( ( 100% - 30px ) / 3)'}}>
                                                  <ActivityPending
                                                     item={item}
                                                     newSecondSelectColor={newSecondSelectColor}
                                                     title={item.title}
                                                     iconType={2}
                                                     /* customWidth={150}*/
                                                     content={item.content}
                                                     statusMark={this.formateStatus(item.status, item)}
                                                     timeMark={item.createDate ? timeago(item.createDate.time) : ''}
                                                     showPoint={true}
                                                     showX={false}
                                                     onClickItem={() => {
                                                         this.itemClick(item)
                                                         /*showDialog(item.id, item.title, () => {
                                                             this.callback(this.nowType);
                                                         });*/
                                                     }}
                                                     onRemoveItem={() => {
                                                     }}
                                                 />

                                             </div>
                                            
                                         )
                                                 })
                                 }
                                 </div>
                                 : <Scrollbars style={{ height: 360,}}>
                                     <div style={{ height: '100%', display: 'flex',padding: '10px 0 10px 10px', flexWrap:'wrap'  }}>    
                                        {
                                            this.state.list && this.state.list.length > 0 && this.state.list.map((item, index) =>
                                          
                                         
                                
                                                <div className="item" key={index} style={{
                                                    marginRight: 10,
                                                    marginBottom: '10px',
                                                    width: 'calc( ( 100% - 30px ) / 3)'
                                                }}>
                                                    <ActivityPending
                                                        title={item.title}
                                                        iconType={2}
                                                        newSecondSelectColor={newSecondSelectColor}
                                                        content={item.content}
                                                        statusMark={item.statusMark}
                                                        timeMark={item.timeMark}
                                                        showPoint={false}
                                                        showX={false}
                                                        onClickItem={() => {
                                                            this.chekcData(item.record);
                                                        }}
                                                        onRemoveItem={() => {
                                                        }}
                                                        lockStatus={item.lockStatus}
                                                        
                                                    />
                                                </div> 
                                            
                                                
                                            )
                                        }
                                     </div>
                               

                                 </Scrollbars>
                            )
                        )
                    }
                 
                <TabModal visible={this.state.newsActivityViewVisible}
                          onCancel={() => {
                              this.setState({
                                  newsActivityViewVisible: false
                              }, () => {this.getMyTask();})
                          }}
                          activeIndex={this.state.newsActivityViewActiveIndex}
                          width={1100}
                          tabs={[{
                              title: "基本信息",
                              footer: <div className={"ant-modal-footer"}>
                                  <NewsActivityBaseInfoFooter
                                      currentUser={this.props.currentUser}
                                      data={this.state.newsActivity}
                                      takeTaskAfter={() => {
                                          let {newsActivityViewTabs, newsActivityViewTabPanels} = this.handleNewsActivityViewTabs(this.state.newsActivity);
                                          this.setState({newsActivityViewTabs, newsActivityViewTabPanels});
                                      }}
                                      update={(id) => this.updateDataById(id)}
                                      cencel={() => {
                                          this.setState({
                                              newsActivityViewVisible: false
                                          })
                                      }}
                                  />
                              </div>
                          }, {
                              title: "拟发平台",
                              footer: null
                          }, {
                              title: "分派记者",
                              footer: null
                          }, ...this.state.newsActivityViewTabs]}
                          tabPanels={[<NewsActivityBaseInfo data={this.state.newsActivity}/>,
                              <NewsActivityPublishPlatform data={this.state.newsActivity}/>,
                              <NewsActivityReporter data={this.state.newsActivity}/>,
                              ...this.state.newsActivityViewTabPanels]}/>

                <TaskAll ref={TaskAll => this.TaskAll = TaskAll} newSecondSelectColor={newSecondSelectColor}
                         callBack={(data) => {
                             this.itemClick(data)
                         }}/>


                <Modal key={uuid()}
                       title={"编辑微博"}
                       visible={this.state.editWeiboVisible}
                       onCancel={this.closeWeibo.bind(this)}
                       bodyStyle={{height:"680px"}}
                       width={860}
                       footer={null}
                       keyboard={false}
                       maskClosable={false}
                >
                    <EditWeiBo refreshList={this.refreshList} fatherObj={this} currentMedia={this.eidtWeiboMediaCode}
                               weiboId={this.eidtWeiboId} touTiaoParms={this.state.touTiaoParms}
                               touTiaoParmsCallback={(data)=>{
                        //回调传入微博头条编辑器
                        let parms={
                            ...data,
                        };
                        this.state.editWeiboVisible=false;
                        this.setState({});
                        this.Headlines.showModal(parms)
                    }} changeLoading={(status)=>{this.childLoading = status}}/>

                </Modal>
                <MaterialModel visible={this.state.editModalVisible} title={this.weChatParams.title}
                               mediaCode={this.weChatParams.mediaCode} materialId={this.weChatParams.materialId}
                               refeshList={()=>{this.getMyOtherDate()}}
                               updateVisible={()=>{this.setState({editModalVisible:false})}}
                />
            </div>
            </div>
        )
    }


    formateStatus(value, row) {

        let activityTime;//活动时间
        if (row.endDate) {
            activityTime = row.endDate.time;
        } else {
            activityTime = row.interviewEndDate ? row.interviewEndDate.time : 0;//活动时间
        }
        let nowDate = new Date().getTime();//当前时间
        if (value == 1) {
            let statusName = "未领取";
            if (activityTime) {
                statusName = activityTime < nowDate ? '已超期' : '未领取';
            }
            return statusName
        } else if (value == 2) {
            return '进行中'
        } else if (value == 3) {
            return '已提交'
        } else if (value == 4) {
            return '已完成'
        }
    }

    itemClick(item) {
        this.viewNewActivityById(item.id);
    }

    viewNewActivityById = (id) => {
        window.loading.show();
        getNewsActivityById(id, (newsActivity) => {
            window.loading.hide();
            let {newsActivityViewTabs, newsActivityViewTabPanels} = this.handleNewsActivityViewTabs(newsActivity);
            if(newsActivity.interviewJointers && newsActivity.interviewJointers.length){
                newsActivity.interviewJointers.forEach((item,index)=>{
                    if(item.status === 3){
                        item.status = 2
                    }
                })
            }
            this.setState({
                stepVisible: false,
                newsActivityViewVisible: true,
                newsActivityViewActiveIndex: 0,
                newsActivityViewTabs, newsActivityViewTabPanels,
                newsActivity
            });
        });
    };

    handleNewsActivityViewTabs(newsActivity) {
        let newsActivityViewTabs = [];
        let newsActivityViewTabPanels = [];
        let roleComponentMap = {
            type_1: {
                tab: {title: "任务稿件", footer: null}, tabPanel: <NewsActivityWriteStory refreshParentMethod={() => {
                   /* newsActivity.status = 3;*/
                    this.setState({newsActivity, newsActivityViewActiveIndex: 3})
                }} currentUser={this.props.currentUser} data={newsActivity}/>, push: false
            },
            type_2: {
                tab: {title: "任务图片", footer: null},
                tabPanel: <NewsActivityPicture currentUser={this.props.currentUser} data={newsActivity}/>,
                push: false
            },
            type_3: {
                tab: {title: "任务视频", footer: null},
                tabPanel: <NewsActivityVideo currentUser={this.props.currentUser} data={newsActivity}/>,
                push: false
            },
            type_4: {
                tab: {title: "美工附件", footer: null},
                tabPanel: <NewsActivityArtFile currentUser={this.props.currentUser} data={newsActivity}/>,
                push: false
            },
        };

        //先看看当前角色是不是主任，如果是主任的话，那就直接判断有没有人领取
        let isEditAuth = false;
        if (this.props.currentUser && this.props.currentUser.roleCodes) {
            // isEditAuth = this.props.currentUser.roleCodes.indexOf(haveEditAuthRoleCode) !== -1;
            isEditAuth=permissionCheck("pms:topicSelect:chooseUsing")
        }
        if (newsActivity && this.props.currentUser) {
            //查看当前的记者有哪些角色
            if (newsActivity.interviewJointers) {
                newsActivity.interviewJointers.map(jointer => {
                    if (isEditAuth || (jointer.account === this.props.currentUser.account)) {
                        //判断是否已经领取了
                        if (jointer.status !== 1 && !roleComponentMap["type_" + jointer.interviewRole].push) {//已领取才显示
                            newsActivityViewTabs.push(roleComponentMap["type_" + jointer.interviewRole].tab);
                            newsActivityViewTabPanels.push(roleComponentMap["type_" + jointer.interviewRole].tabPanel);
                            roleComponentMap["type_" + jointer.interviewRole].push = true;
                        }
                    }
                });
            }
        }

        return {newsActivityViewTabs, newsActivityViewTabPanels};
    }

    //其他待我处理的逻辑
    refreshList = () => {
        this.setState({  loading:true});
        this.getMyOtherDate();
        this.closeWeibo();
    }

    //查看按钮，不同的流程，不同的媒体弹不同的框
    chekcData(record) {
        let obj = record.data;
        if (record.pojoName == "story") {
            if (obj.storyType == 1 || obj.storyTypeStr == 'PIC') {
                this.viewGroupPicStory(record);
            } else{
                this.websiteViewStory(record);
            }
        } else if (record.pojoName == "material") {
            this.weixinViewMaterial(record);
        } else if (record.pojoName == "weibo") {
            this.websiteViewWeibo(record);
        } else if (record.pojoName == "applyForResource") {
            this.downloadSourceView(record);
        } else if (record.pojoName == "douyin") {
            this.douyinViewMaterial(record);
        } else if (record.pojoName == "urlstory") {
            this.urlStoryView(record);
        }
    }


    /**
     * 查看组图稿件
     * @param record
     */
    viewGroupPicStory(record) {
        let that = this
        let obj = record.data;
        let url = "/cm-sites/pms/addContribute/atlasdetail.html?currentStoryId=" + obj.id + "&currentMediaCode=" + obj.mediaCode + "&treeId=" + obj.news.treeId + "&treeContentId=" + obj.news.treeContentId ;
        window.openFull(url, "编辑组图", null, {
                shade: 0.5,
                area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
            }, null,
            function () {
                myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
                that.refreshList();
            });
    }

    //关闭微博和微信弹窗
    closeWeibo = () => {
        if(!this.childLoading){
            this.setState({
                editWeiboVisible: false,
                editModalVisible: false
            });
        }
    };

    updateMyReviewGrid(myAuditdata) {
        let number = 0;
        if (myAuditdata.data && myAuditdata.data.length > 0) {
            for (let i = 0; i < myAuditdata.data.length; i++) {
                if (myAuditdata.data[i].deploymentkey === "downloadSource") {
                    number += 1;
                }
            }
        }
        this.setState({
            myAuditdatas: myAuditdata.data,
            needTodoCount: myAuditdata.data ? myAuditdata.data.length : 0,
            myAuditloading: true,
            downloadSourceNumber: number,
            editModalVisible: false,
            editWeiboVisible: false,
        })
    }

    /**
     * 链接稿件的查看功能
     */
    urlStoryView(record) {
        let that = this;
        let data = record;
        let object = data.data;
        let title = "";
        if (object.storyTypeStr.indexOf("WEIBO")) {
            title = "微博链接稿件";
        } else if (object.storyTypeStr.indexOf("WEIBO")) {
            title = "微信链接稿件";
        }
        let url = "/cm-sites/pms/website/wechat/wechatAdd.html?id=" + object._serviceId + "&actButtonId=10&fromHome=home"; //流程id会需要根据部署进行修改！
        if (object._ProcessInstanceId) {
            url += "&processInstanceId=" + object._ProcessInstanceId;
        } else {
            url += "&processInstanceId=0";
        }
        // window.openFull(url,title,null,null,null,function() {
        //     myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
        // });
        window.layer.open({
            title: title,
            type: 2,
            content: url,
            area: ['800px', '510px'],
            success: function (layero, index) {
                var iframeWin = window[layero.find('iframe')[0]['name']];
            }, end: function () {
                myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
                that.getMyOtherDate();
            }
        });
    }

    /**
     * 抖音的查看功能
     */
    douyinViewMaterial(record) {
        let that = this;
        let data = record;
        let object = data.data;
        let url = "/cm-sites/pms/douyin/publish.html?currentMedia=" + object.mediaCode + "&id=" + object.id + "&actButtonId=20";
        window.openFull(url, "抖音", null, {
            area:['750px','650px'],
            shade:0.5,
            resize:false,
        }, null, function () {
            myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
            that.getMyOtherDate();
        });
    }

    /**
     * 资源下载申请
     * @param record
     */
    downloadSourceView(record) {
        let that = this;
        window.layer.open({
            title: '资源下载审核',
            type: 2,
            content: '/cm-sites/' + applicationName() + '/downloadApplication/downloadApplication.html?actButtonId=8&id=' + record.data.id,
            area: [parseInt(document.body.clientWidth * 0.76) + 'px', parseInt(document.body.clientHeight * 0.8) + 'px'],
            success: function (layero, index) {
                var iframeWin = window[layero.find('iframe')[0]['name']];
            }, end: function () {
                myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
                that.getMyOtherDate();
            }
        });
    }

    eidtWeiboMediaCode;
    eidtWeiboId;
    // 微博编辑页面是否正在loading
    childLoading = false;
    /**
     * 微博查看功能
     * @param record
     */
    websiteViewWeibo(record) {
        this.eidtWeiboMediaCode = record.data.mediaCode;
        this.eidtWeiboId = record.data.id;
        this.setState({
            editWeiboVisible: true,
            editModalVisible: false,
            touTiaoParms: record.data
        })
    }

    /**
     * 微信的查看功能
     */
    weixinViewMaterial(record) {
        this.weChatParams = {
            title: "编辑素材",
            materialId: record.data.id,
            mediaCode: record.data.mediaCode
        };
        this.setState({
            editModalVisible: true,
            editWeiboVisible: false,
        })
    }

    /**
     *稿件的查看  unfzr 的查看
     * @param record
     */
    showInterview(record) {
        let that = this;
        let interviewId = record.data.interviewId;
        let width = parseInt(window.document.body.clientWidth * 0.9);
        let height = parseInt(window.document.body.clientHeight * 0.9);
        // window.location.hash = '#/interviewTask/interviewTaskdetail/'+interviewId;
        window.openFull("/cm-sites/pms/interviewTask/interviewTaskdetail.html?interviewId=" + interviewId, record.title, null, {area: [width + 'px', height + 'px']}, null, function () {
            myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
            that.getMyOtherDate();
        });
    }

    /**
     * 稿件的查看 （投稿端）
     * @param record
     */
    viewStory(record) {
        let that = this;
        var data = record.data;

        let width = parseInt(window.document.body.clientWidth * 0.9);
        let height = parseInt(window.document.body.clientHeight * 0.9);

        window.openFull("/cm-sites/pms/writing/writingNew.html?eiditStoryId=" + data._serviceId
            + "&processInstanceId=" + data._ProcessInstanceId + "&actButtonId=2", record.title, null, {area: [width + 'px', height + 'px']}, null, function () {
            myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
            that.getMyOtherDate();
        });
    }

    /**
     * 稿件的查看  （管理端）
     * @param record
     */
    websiteViewStory(record) {
        let that = this;

        let width = parseInt(window.document.body.clientWidth * 0.9);
        let height = parseInt(window.document.body.clientHeight * 0.9);
        let synColumns = record.data.news;
        let mainColumnInfo = synColumns.filter(item => item.mainColumn == 1)[0];

        let treeContentId = 0;
        let mediaCode = "";
        if (mainColumnInfo) {
            //window.layer.alert("主栏目信息获取错误，无法打开该文章");
            if (mainColumnInfo.treeContentId) {
                treeContentId = mainColumnInfo.treeContentId;
            }
            if (mainColumnInfo.mediaCode) {
                mediaCode = mainColumnInfo.mediaCode;
            }
        }
        let interviewId = record.data.interviewId || 0;
        window.openFull("/cm-sites/pms/addContribute/addContributeNews.html?interviewId="  +interviewId+ "&eiditStoryId=" + record.data.id + "&treeContentId=" + treeContentId + "&currentMediaCode=" + (mediaCode || record.data.mediaCode) + "&passMediaCodes=" + (mediaCode || record.data.mediaCode)
            , record.title, null, {area: [width + 'px', height + 'px']}, null, function () {
            myReviewGridData(that.props.currentUser, that.updateMyReviewGrid.bind(that));
            that.refreshList();
        });

    }

    /**
     * 获取标题
     * @param recorde
     */
    getTitle(recorde) {
        let obj = recorde.data;
        let returnObj = {};
        let title = "";
        let type = "";
        if (recorde.pojoName === "story" ) {
            title = obj.title;
            type = "稿件";
        } else if (recorde.pojoName === "material") {
            if (obj.stuffList && obj.stuffList[0]) {
                title = obj.stuffList[0].title;
            }
            type = "微信";
        } else if (recorde.pojoName === "weibo") {
            title = obj.content;
            type = "微博";
        } else if (recorde.pojoName === "applyForResource") {
            title = recorde.data.userName + "-" + recorde.data.deptName + "-" + window.formatDate(recorde.data.createTime).substring(0, 10);
            type = "资源下载申请";
        } else if (recorde.pojoName === "douyin") {
            title = obj.title;
            type = "抖音";
        }
        returnObj.title = title;
        returnObj.type = type;
        return returnObj;
    }

    /**
     * 获取标题
     * @param recorde
     */
    getIcon(recorde) {
        let li = "";
        if (recorde.deploymentkey.indexOf("story") === 0 || recorde.deploymentkey === "yuegao"
            || recorde.deploymentkey === "fzr" || recorde.deploymentkey === "unfzr" || recorde.deploymentkey === "activityStory") {
            li = 'icon icon-pc';
        } else if (recorde.deploymentkey === "weixin") {
            li = 'icon icon-wechat';
        } else if (recorde.deploymentkey === "weibo") {
            li = 'icon icon-wb';
        } else if (recorde.deploymentkey === "downloadSource") {
            li = 'icon icon-downloadSource';
        } else if (recorde.deploymentkey === "douyin") {
            li = 'icon icon-dy';
        }
        return li;
    }


}

function mapStateToProps(state) {
    return {
        navigateData: state.systemReducer.navigateData,
        navigateStatus: state.systemReducer.navigateStatus,
        currentUser: state.systemReducer.currentUser,
        config: state.systemReducer.config,
    }
}

function mapStateToMethod(dispatch) {
    return {
        shrinNavigateStauts: function () {
            return dispatch(shrinNavigateStauts());
        },
        updateNavigateLevel2Data: function (title, data) {
            return dispatch(updateNavigateLevel2Data(title, data));
        }
    }
}

export default connect(mapStateToProps, mapStateToMethod)(ActivityPendingComponents);

//获取待我处理的任务;
export const getMyTask = (body, callBack) => {
    let url = "/cm-sites-pms/interview/myInterviewGetAndNotGet";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(body)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getMyTask", error);
        callBack("");
    })
}

export const getMyOther = (callBack) => {
    let url = "/cm-sites-activiti/activiti/getNeedProcessedAll";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getMyInterView", error);
        callBack("");
    })
};


export const checkLock = (body) => {
    let url = "/cm-sites-pms/webberLock/checkLock";
    return new  Promise((resolve, reject) => {
        fetch(url, {
            method: 'post',
            cache: 'no-cache',
            headers: headers,
            credentials: 'include',
            body: formateData(body)
        }).then(response => response.json()).then(data => {
           
            resolve(data)
        }).catch((error) => {
            console.error("actionError:getMyInterView", error);
            reject('失败了')
        })
    })
};

function showDialog(interviewId, interviewName, endFun) {
    window.layer.open({
        id: "weibo",
        //btn: ['确定', '关闭'],
        btn: null,
        type: 2,//0（信息框，默认）1（页面层）2（iframe层）3（加载层）4（tips层）。
        content: "/cm-sites/pms/interviewTask/interviewTaskdetail.html?interviewId=" + interviewId,
        title: interviewName,
        resize: true,
        shade: 0.001,	//遮罩
        //shade : 0,
        //shadeClose : true,	//点击遮罩是否关闭
        zIndex: 100,
        area: [parseInt(window.$(window).width() * 0.9) + 'px', parseInt(window.$(window).height() * 0.9) + 'px'],
        yes: function (index, layero) {

        },
        end: function () {
            if (endFun) {
                endFun();
            }
        }
    })
}